var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    className: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "setting-filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.999 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15792",
    "data-name": "Path 15792",
    d: "M507.949,739.05a.848.848,0,0,1-.247-.1.871.871,0,0,1-.289-1.2,3.271,3.271,0,0,0-4.5-4.492.863.863,0,0,1-.247.1.872.872,0,0,1-1.05-.641,3.269,3.269,0,0,0-6.351,0v0a.9.9,0,0,1-.1.247.868.868,0,0,1-1.194.287,3.271,3.271,0,0,0-4.493,4.494.888.888,0,0,1,.1.247.869.869,0,0,1-.641,1.049,3.269,3.269,0,0,0,0,6.353.893.893,0,0,1,.246.1.87.87,0,0,1,.289,1.2,3.271,3.271,0,0,0,4.5,4.492.877.877,0,0,1,.247-.1.87.87,0,0,1,1.05.642,3.269,3.269,0,0,0,6.351,0,.87.87,0,0,1,1.3-.539,3.27,3.27,0,0,0,4.491-4.5.826.826,0,0,1-.1-.245.866.866,0,0,1,.641-1.049,3.269,3.269,0,0,0,0-6.353Zm.07,3.38a.868.868,0,0,1-.637.641,3.266,3.266,0,0,0-2.022,4.874.872.872,0,0,1-.292,1.2.863.863,0,0,1-.9,0,3.27,3.27,0,0,0-4.875,2.02.868.868,0,0,1-1.687,0,3.272,3.272,0,0,0-4.878-2.023.87.87,0,0,1-1.2-1.194,3.265,3.265,0,0,0-2.018-4.876.87.87,0,0,1,0-1.69,3.268,3.268,0,0,0,2.022-4.876.87.87,0,0,1,1.194-1.2,3.272,3.272,0,0,0,4.491-1.087,3.328,3.328,0,0,0,.386-.931.868.868,0,0,1,1.687,0,3.27,3.27,0,0,0,4.877,2.023.87.87,0,0,1,1.2,1.194,3.265,3.265,0,0,0,2.018,4.876A.87.87,0,0,1,508.019,742.43Z",
    transform: "translate(-486.446 -730.226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15793",
    "data-name": "Path 15793",
    d: "M497.246,736.227a4.8,4.8,0,1,0,4.8,4.8A4.8,4.8,0,0,0,497.246,736.227Zm0,7.2a2.4,2.4,0,1,1,2.4-2.4A2.4,2.4,0,0,1,497.246,743.427Z",
    transform: "translate(-485.246 -729.026)"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "consultations-filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_64-Interview",
    "data-name": "64-Interview",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12965",
    "data-name": "Path 12965",
    d: "M4.571,14.857A3.429,3.429,0,1,1,8,18.286,3.429,3.429,0,0,1,4.571,14.857Zm6,4.286H5.429A3.429,3.429,0,0,0,2,22.571v2.571A.857.857,0,0,0,2.857,26H13.143A.857.857,0,0,0,14,25.143V22.571A3.429,3.429,0,0,0,10.571,19.143ZM26,4.571V9.714a2.571,2.571,0,0,1-2.571,2.571H20.283l-3.2,2.4A.859.859,0,0,1,15.714,14V12.286H13.143a2.571,2.571,0,0,1-2.571-2.571V4.571A2.571,2.571,0,0,1,13.143,2H23.429A2.571,2.571,0,0,1,26,4.571ZM15.714,7.143A.857.857,0,1,0,14.857,8,.857.857,0,0,0,15.714,7.143Zm3.429,0A.857.857,0,1,0,18.286,8,.857.857,0,0,0,19.143,7.143Zm3.429,0A.857.857,0,1,0,21.714,8,.857.857,0,0,0,22.571,7.143Zm1.714,10.286A2.571,2.571,0,1,0,21.714,20a2.571,2.571,0,0,0,2.571-2.571Zm-.857,3.429H20a2.571,2.571,0,0,0-2.571,2.571v1.714a.857.857,0,0,0,.857.857h6.857A.857.857,0,0,0,26,25.143V23.429A2.571,2.571,0,0,0,23.429,20.857Z",
    transform: "translate(-2 -2)"
  })))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    id: "discount-coupon-filled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3,26.7c1.1-0.5,1.7-1.6,1.7-2.7V16c0-1.7-1.3-3-3-3H8c-1.7,0-3,1.3-3,3v7.8C5,25,5.7,26,6.8,26.5 c2.1,1,3.5,3.1,3.5,5.5S9,36.5,6.8,37.5C5.7,38,5,39,5,40.2V48c0,1.7,1.3,3,3,3h48c1.7,0,3-1.3,3-3v-7.9c0-1.1-0.7-2.2-1.7-2.7 c-2-1-3.3-3.1-3.3-5.3S55.3,27.7,57.3,26.7z M52,32c0,3,1.7,5.8,4.4,7.1c0.4,0.2,0.6,0.6,0.6,0.9V48c0,0.6-0.4,1-1,1H8 c-0.6,0-1-0.4-1-1v-7.8c0-0.4,0.3-0.8,0.7-0.9c2.9-1.3,4.7-4.2,4.7-7.3s-1.8-6-4.7-7.3C7.3,24.5,7,24.2,7,23.8V16c0-0.6,0.4-1,1-1 h48c0.6,0,1,0.4,1,1v7.9c0,0.4-0.2,0.7-0.6,0.9C53.7,26.2,52,29,52,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 34c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5S41.8 34 39 34zM39 42c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S40.7 42 39 42zM25 30c2.8 0 5-2.2 5-5s-2.2-5-5-5-5 2.2-5 5S22.2 30 25 30zM25 22c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3S23.3 22 25 22zM43 23.9c0-.8-.3-1.5-.9-2.1-1.1-1.1-3-1.1-4.1 0L21.9 38c-.5.5-.9 1.3-.9 2.1 0 .8.3 1.5.9 2.1.6.6 1.3.9 2.1.9.7 0 1.5-.3 2.1-.9L42.1 26C42.7 25.4 43 24.7 43 23.9zM40.7 24.5C40.7 24.5 40.7 24.5 40.7 24.5L24.5 40.7c-.4.4-.9.4-1.3 0-.2-.2-.3-.4-.3-.6s.1-.5.3-.6l16.2-16.2c.2-.2.4-.3.6-.3s.5.1.6.3c.2.2.3.4.3.6S40.9 24.4 40.7 24.5z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "disscount-coupon-filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 16.615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coupon",
    transform: "translate(-3 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34401",
    "data-name": "Path 34401",
    d: "M24.231,23.615H5.769A2.769,2.769,0,0,1,3,20.846V19a.923.923,0,0,1,.923-.923,2.769,2.769,0,0,0,0-5.538A.923.923,0,0,1,3,11.615V9.769A2.769,2.769,0,0,1,5.769,7H24.231A2.769,2.769,0,0,1,27,9.769v1.846a.923.923,0,0,1-.923.923,2.769,2.769,0,0,0,0,5.538A.923.923,0,0,1,27,19v1.846a2.769,2.769,0,0,1-2.769,2.769ZM4.846,19.831v1.015a.923.923,0,0,0,.923.923H24.231a.923.923,0,0,0,.923-.923V19.831a4.615,4.615,0,0,1,0-9.046V9.769a.923.923,0,0,0-.923-.923H5.769a.923.923,0,0,0-.923.923v1.015a4.615,4.615,0,0,1,0,9.046Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34402",
    "data-name": "Path 34402",
    d: "M12.923,9.769A.923.923,0,0,1,12,8.846V7.923a.923.923,0,1,1,1.846,0v.923A.923.923,0,0,1,12.923,9.769Z",
    transform: "translate(-0.692)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34403",
    "data-name": "Path 34403",
    d: "M12.923,24.769A.923.923,0,0,1,12,23.846v-.923a.923.923,0,1,1,1.846,0v.923A.923.923,0,0,1,12.923,24.769Z",
    transform: "translate(-0.692 -1.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34404",
    "data-name": "Path 34404",
    d: "M12.924,13.846a.923.923,0,1,1,.655-.268.969.969,0,0,1-.655.268Z",
    transform: "translate(-0.693 -0.385)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34405",
    "data-name": "Path 34405",
    d: "M12.924,16.846a1.007,1.007,0,1,1,.351-.074A.923.923,0,0,1,12.924,16.846Z",
    transform: "translate(-0.693 -0.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34406",
    "data-name": "Path 34406",
    d: "M12.924,19.846a.923.923,0,1,1,.655-.268.969.969,0,0,1-.655.268Z",
    transform: "translate(-0.693 -0.846)"
  })))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "add-filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add",
    transform: "translate(-1 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15562",
    "data-name": "Path 15562",
    d: "M8.5,19V14.5H13v-3H8.5V7h-3v4.5H1v3H5.5V19Z",
    transform: "translate(0 0)"
  })))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "analytics-filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.999 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "analytics",
    d: "M502.045,390.226h-14.4a1.2,1.2,0,0,1-1.2-1.2v-15a2.4,2.4,0,0,1,2.4-2.4h4.8v-3a2.4,2.4,0,0,1,2.4-2.4h4.8a2.4,2.4,0,0,1,2.4,2.4v8.4h4.8a2.4,2.4,0,0,1,2.4,2.4v9.6a1.2,1.2,0,0,1-1.2,1.2Zm6-2.4v-8.4h-4.8v8.4Zm-12,0h4.8v-19.2h-4.8Zm-7.2,0h4.8v-13.8h-4.8Z",
    transform: "translate(-486.446 -366.226)"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "home-filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.999 24.003"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Home",
    d: "M15.6,24H6a3.609,3.609,0,0,1-3.6-3.6V13.2H1.2A1.2,1.2,0,0,1,.35,11.152l10.8-10.8a1.187,1.187,0,0,1,1.691,0l10.8,10.8A1.2,1.2,0,0,1,22.8,13.2H21.6v7.2A3.608,3.608,0,0,1,18,24ZM18,21.6a1.2,1.2,0,0,0,1.2-1.2V11.941a.038.038,0,0,0,0-.015c0-.014,0-.029,0-.043s0-.009,0-.014a1.191,1.191,0,0,1,.475-.831s0,0,.006,0l.035-.025L19.734,11l.018-.011a1.228,1.228,0,0,1,.227-.113L12,2.9,4.021,10.877c.037.014.076.03.113.048l.033.017,0,0a1.192,1.192,0,0,1,.619.927v.008c0,.016,0,.031,0,.047v.014c0,.019,0,.038,0,.057v8.4A1.2,1.2,0,0,0,6,21.6H7.2v-6A3.6,3.6,0,0,1,10.8,12h2.4a3.6,3.6,0,0,1,3.6,3.6v6Zm-3.6,0v-6a1.2,1.2,0,0,0-1.2-1.2H10.8A1.2,1.2,0,0,0,9.6,15.6v6Z",
    transform: "translate(0 0.001)"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "signout-filled",
    "data-name": "sign out",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.998 23.998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15247",
    "data-name": "Path 15247",
    d: "M12.878,31.5H1.5a1.5,1.5,0,0,1,0-3H12.878l-1.939-1.939A1.5,1.5,0,1,1,13.06,24.44l4.5,4.5a1.5,1.5,0,0,1,0,2.121l-4.5,4.5a1.5,1.5,0,0,1-2.121-2.121Z",
    transform: "translate(5.999 -18.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15248",
    "data-name": "Path 15248",
    d: "M37.5,0h12A1.5,1.5,0,0,1,51,1.5v3a1.5,1.5,0,0,1-3,0V3H39V21h9V19.5a1.5,1.5,0,0,1,3,0v3A1.5,1.5,0,0,1,49.5,24h-12A1.5,1.5,0,0,1,36,22.5V1.5A1.5,1.5,0,0,1,37.5,0Z",
    transform: "translate(-36 0)"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus-filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "plus-solid",
    d: "M18.571,39.857H12.143V33.429A1.429,1.429,0,0,0,10.714,32H9.286a1.429,1.429,0,0,0-1.429,1.429v6.429H1.429A1.429,1.429,0,0,0,0,41.286v1.429a1.429,1.429,0,0,0,1.429,1.429H7.857v6.429A1.429,1.429,0,0,0,9.286,52h1.429a1.429,1.429,0,0,0,1.429-1.429V44.143h6.429A1.429,1.429,0,0,0,20,42.714V41.286A1.429,1.429,0,0,0,18.571,39.857Z",
    transform: "translate(0 -32)"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "courses-filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "courses",
    d: "M30,1.875A1.875,1.875,0,0,0,28.125,0H1.875A1.875,1.875,0,0,0,0,1.875v7.5a.312.312,0,0,0,.312.312H7.3A.313.313,0,0,0,7.589,9.5l.945-2.206a1.555,1.555,0,0,1,1.435-.946H10a1.556,1.556,0,0,1,1.429,1l1.6,4.165a.314.314,0,0,0,.566.037l1.944-3.563a1.57,1.57,0,0,1,1.323-.815,1.593,1.593,0,0,1,1.375.735l1.322,2.117a.313.313,0,0,0,.55-.036l2.16-4.749a.937.937,0,0,1,1.706.776l-2.641,5.812a1.563,1.563,0,0,1-2.75.182l-1.375-2.2a.313.313,0,0,0-.539.016L14.6,13.635a1.563,1.563,0,0,1-2.829-.185l-1.537-4a.313.313,0,0,0-.579-.01l-.5,1.17a1.563,1.563,0,0,1-1.435.946H.313A.312.312,0,0,0,0,11.872v5.78a1.875,1.875,0,0,0,1.875,1.875H12.812V21.62a2.652,2.652,0,0,0-.426.342L7.02,27.327a1.563,1.563,0,1,0,2.21,2.21l4.924-4.916a.313.313,0,0,1,.443,0l4.924,4.923a1.563,1.563,0,1,0,2.21-2.21l-5.366-5.365a2.709,2.709,0,0,0-.426-.342v-2.1H28.125A1.875,1.875,0,0,0,30,17.652Z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "users-filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.5 30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Users",
    transform: "translate(-747 -356.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "studentsNumber",
    d: "M13.125,15a7.5,7.5,0,1,0-7.5-7.5A7.5,7.5,0,0,0,13.125,15ZM16.1,17.812H10.154A10.154,10.154,0,0,0,0,27.967,2.031,2.031,0,0,0,2.031,30H24.217a2.031,2.031,0,0,0,2.033-2.033A10.155,10.155,0,0,0,16.1,17.812Zm11.977.938H23.745a11.869,11.869,0,0,1,4.38,9.217A3.871,3.871,0,0,1,27.539,30h8.086A1.889,1.889,0,0,0,37.5,28.072,9.373,9.373,0,0,0,28.072,18.75ZM25.313,15A6.563,6.563,0,1,0,21.4,3.194,9.288,9.288,0,0,1,22.5,7.5a9.3,9.3,0,0,1-1.851,5.549A6.541,6.541,0,0,0,25.313,15Z",
    transform: "translate(747 356.625)"
  })))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "hand-dollar-filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.75 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hand-holding-dollar-solid",
    d: "M18.281,1.406v.615c.375.07.738.158,1.066.246a1.407,1.407,0,1,1-.727,2.719,7.419,7.419,0,0,0-1.77-.293,2.363,2.363,0,0,0-1.137.258.671.671,0,0,0-.205.176.279.279,0,0,0-.041.164v.035a.67.67,0,0,0,.193.152,7.653,7.653,0,0,0,1.605.592l.053.018h0a9.192,9.192,0,0,1,2.221.9,3.078,3.078,0,0,1,1.547,2.631,3.222,3.222,0,0,1-1.564,2.842,4.361,4.361,0,0,1-1.248.516v.621a1.406,1.406,0,1,1-2.812,0v-.668c-.557-.135-1.066-.311-1.5-.457-.123-.041-.24-.082-.352-.117A1.408,1.408,0,1,1,14.5,9.68l.428.146a7.1,7.1,0,0,0,1.986.486,2.127,2.127,0,0,0,1.125-.24.544.544,0,0,0,.188-.17.4.4,0,0,0,.047-.24V9.65c0-.059,0-.123-.234-.27a7.125,7.125,0,0,0-1.588-.6l-.111-.035A9.318,9.318,0,0,1,14.209,7.9,2.962,2.962,0,0,1,12.65,5.314a3.156,3.156,0,0,1,1.623-2.777,4.57,4.57,0,0,1,1.184-.48v-.65a1.406,1.406,0,1,1,2.812,0Zm15.012,18.3a2.341,2.341,0,0,1-.5,3.275l-7.418,5.467A7.976,7.976,0,0,1,20.648,30H1.875A1.873,1.873,0,0,1,0,28.125v-3.75A1.873,1.873,0,0,1,1.875,22.5H4.031l2.631-2.109A7.485,7.485,0,0,1,11.35,18.75h9.275a1.875,1.875,0,0,1,0,3.75H15.938a.938.938,0,1,0,0,1.875H23l7.014-5.168A2.341,2.341,0,0,1,33.293,19.705ZM11.344,22.5Z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "articles-filled",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 20.5,
    viewBox: "0 0 20.5 20.5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "articles",
    transform: "translate(22.25 -1.75) rotate(90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18796",
    "data-name": "Rectangle 18796",
    width: 18,
    height: 18,
    rx: 2,
    transform: "translate(3 3)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18797",
    "data-name": "Rectangle 18797",
    width: 3,
    height: 9,
    transform: "translate(7 7)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18798",
    "data-name": "Rectangle 18798",
    width: 3,
    height: 5,
    transform: "translate(14 7)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "lock-stroke",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.5 22.5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "password",
    transform: "translate(-1.75 -0.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3337",
    "data-name": "Rectangle 3337",
    width: 18,
    height: 11,
    rx: 2,
    transform: "translate(3 11)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34357",
    "data-name": "Path 34357",
    d: "M7,11V7A5,5,0,0,1,17,7v4",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "exclamation-circle-stroke",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert-circle",
    transform: "translate(-1 -1.233)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_661",
    "data-name": "Ellipse 661",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(2 2.233)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1094",
    "data-name": "Line 1094",
    y2: 3,
    transform: "translate(10 7.233)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1095",
    "data-name": "Line 1095",
    transform: "translate(10 13.233)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "question-circle-stroke",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 22.5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "help-circle",
    transform: "translate(-0.75 -0.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_660",
    "data-name": "Ellipse 660",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(2 2)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34997",
    "data-name": "Path 34997",
    d: "M9.09,9a3,3,0,0,1,5.83,1c0,2-3,3-3,3",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1089",
    "data-name": "Line 1089",
    x2: 0.01,
    transform: "translate(12 17)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "history-stroke",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.5 22.5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "history",
    transform: "translate(-2.75 -0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34998",
    "data-name": "Path 34998",
    d: "M14,2H6A2,2,0,0,0,4,4V20a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V8Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34999",
    "data-name": "Path 34999",
    d: "M14,2V8h6",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1090",
    "data-name": "Line 1090",
    x1: 8,
    transform: "translate(8 13)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1091",
    "data-name": "Line 1091",
    x1: 8,
    transform: "translate(8 17)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35000",
    "data-name": "Path 35000",
    d: "M10,9H8",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "date-filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "date",
    transform: "translate(-3 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15543",
    "data-name": "Path 15543",
    d: "M19,4H18V2H16V4H8V2H6V4H5A1.991,1.991,0,0,0,3.01,6L3,20a2,2,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V6A2.006,2.006,0,0,0,19,4Zm0,16H5V10H19ZM19,8H5V6H19ZM9,14H7V12H9Zm4,0H11V12h2Zm4,0H15V12h2ZM9,18H7V16H9Zm4,0H11V16h2Zm4,0H15V16h2Z"
  })))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "dollar-sign-stroke",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.5 24.5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dollar-sign",
    transform: "translate(-4.75 0.25)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1093",
    "data-name": "Line 1093",
    y2: 22,
    transform: "translate(12 1)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35004",
    "data-name": "Path 35004",
    d: "M17,5H9.5a3.5,3.5,0,0,0,0,7h5a3.5,3.5,0,1,1,0,7H6",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "book-filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 3H7a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM7 5h11v10H7a3 3 0 0 0-1 .18V6a1 1 0 0 1 1-1zm0 14a1 1 0 0 1 0-2h11v2z",
    "data-name": "book"
  })))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "three-users-filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.147 50.4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(0.2 0.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11357",
    "data-name": "Group 11357",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13133",
    "data-name": "Path 13133",
    d: "M68.105,114.25a8.99,8.99,0,1,0-10.315,0,15.577,15.577,0,0,0-5.313,3.116,20.157,20.157,0,0,0-7.292-3.973,11.39,11.39,0,1,0-11.779,0,20.325,20.325,0,0,0-7.214,3.926,15.7,15.7,0,0,0-5.251-3.054,8.99,8.99,0,1,0-10.315,0A15.781,15.781,0,0,0,0,129.177v1.028a.067.067,0,0,0,.062.062H19.118a20.956,20.956,0,0,0-.171,2.633v1.06a8.285,8.285,0,0,0,8.289,8.289H51.387a8.285,8.285,0,0,0,8.289-8.289V132.9a20.954,20.954,0,0,0-.171-2.633h19.18a.067.067,0,0,0,.062-.062v-1.028A15.841,15.841,0,0,0,68.105,114.25Zm-11.655-7.37a6.5,6.5,0,1,1,6.622,6.5h-.249A6.488,6.488,0,0,1,56.451,106.881ZM30.368,103.64a8.9,8.9,0,1,1,9.411,8.881H38.75A8.91,8.91,0,0,1,30.368,103.64ZM9.24,106.881a6.5,6.5,0,1,1,6.622,6.5h-.249A6.5,6.5,0,0,1,9.24,106.881Zm10.315,20.879H2.524a13.313,13.313,0,0,1,13.119-11.888h.187a13.174,13.174,0,0,1,8.492,3.163A20.458,20.458,0,0,0,19.554,127.759Zm37.6,6.2a5.805,5.805,0,0,1-5.8,5.8H27.2a5.805,5.805,0,0,1-5.8-5.8V132.9A17.9,17.9,0,0,1,38.75,115.03c.171.016.358.016.53.016s.358,0,.53-.016A17.9,17.9,0,0,1,57.152,132.9Zm1.854-6.2a20.4,20.4,0,0,0-4.721-8.663,13.238,13.238,0,0,1,8.57-3.225h.187a13.313,13.313,0,0,1,13.119,11.888Z",
    transform: "translate(0 -92.25)",
    strokeWidth: 0.4
  }))))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "book-mouse-filled",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.4,
    height: 50.4,
    viewBox: "0 0 50.4 50.4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "courses",
    transform: "translate(0.2 0.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11359",
    "data-name": "Group 11359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13134",
    "data-name": "Path 13134",
    d: "M45,19.6V5a2.5,2.5,0,0,0-2.5-2.5h-.833a2.5,2.5,0,0,0-2.5-2.5H25a3.312,3.312,0,0,0-2.5,1.152A3.312,3.312,0,0,0,20,0H5.833a2.5,2.5,0,0,0-2.5,2.5H2.5A2.5,2.5,0,0,0,0,5V35.833a2.5,2.5,0,0,0,2.5,2.5H30V42.5A7.509,7.509,0,0,0,37.5,50h5A7.509,7.509,0,0,0,50,42.5V26.667A7.506,7.506,0,0,0,45,19.6ZM41.667,4.167H42.5A.834.834,0,0,1,43.333,5V19.216a7.5,7.5,0,0,0-.833-.049h-.833ZM8.333,1.667h5V12.624l-1.849-2.312a.833.833,0,0,0-1.3,0L8.333,12.624ZM5,2.5a.834.834,0,0,1,.833-.833h.833V15a.833.833,0,0,0,1.484.52l2.683-3.353,2.683,3.353A.833.833,0,0,0,15,15V1.667h5a1.668,1.668,0,0,1,1.667,1.667V30.515A3.286,3.286,0,0,0,19.921,30H5ZM5,31.666H19.921a1.794,1.794,0,0,1,1.726,1.667H5Zm25,5H2.5a.834.834,0,0,1-.833-.833V5A.834.834,0,0,1,2.5,4.167h.833v30A.833.833,0,0,0,4.167,35H30Zm0-3.333H23.353a1.8,1.8,0,0,1,1.73-1.667H30ZM30,30H25.083a3.292,3.292,0,0,0-1.75.516V3.333A1.668,1.668,0,0,1,25,1.667H39.167A.834.834,0,0,1,40,2.5V19.166H37.5a7.509,7.509,0,0,0-7.5,7.5Zm9.167-9.167V31.666h-7.5v-5A5.84,5.84,0,0,1,37.5,20.833ZM48.333,42.5A5.84,5.84,0,0,1,42.5,48.333h-5A5.84,5.84,0,0,1,31.667,42.5V33.333H48.333V42.5Zm0-10.833h-7.5V20.833H42.5a5.84,5.84,0,0,1,5.833,5.833Z",
    strokeWidth: 0.4
  }))))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "trainers-filled",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.654,
    height: 50.4,
    viewBox: "0 0 53.654 50.4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trainers",
    transform: "translate(0.2 0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13121",
    "data-name": "Path 13121",
    d: "M177.8,339.838a3.525,3.525,0,1,0-3.525-3.525A3.525,3.525,0,0,0,177.8,339.838Zm0-5.528a2,2,0,1,1-2,2A2,2,0,0,1,177.8,334.31Z",
    transform: "translate(-155.331 -298.281)",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13122",
    "data-name": "Path 13122",
    d: "M152.2,397.569v4.883a.727.727,0,0,0,.764.716h10.319a.72.72,0,0,0,.757-.716v-4.883a3.207,3.207,0,0,0-3.243-3.2.739.739,0,0,0-.613.286,2.5,2.5,0,0,1-.546.534,2.588,2.588,0,0,1-3.575-.531.741.741,0,0,0-.613-.289,3.213,3.213,0,0,0-3.25,3.2Zm1.521,0a1.731,1.731,0,0,1,1.4-1.694,4.074,4.074,0,0,0,6.009,0,1.728,1.728,0,0,1,1.393,1.694v4.078h-8.8Z",
    transform: "translate(-135.657 -353.169)",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13123",
    "data-name": "Path 13123",
    d: "M292.41,339.838a3.525,3.525,0,1,0-3.525-3.525A3.524,3.524,0,0,0,292.41,339.838Zm0-5.528a2,2,0,1,1-2,2A2,2,0,0,1,292.41,334.31Z",
    transform: "translate(-257.489 -298.281)",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13124",
    "data-name": "Path 13124",
    d: "M267.129,397.569v4.883a.7.7,0,0,0,.729.716h10.319a.751.751,0,0,0,.791-.716v-4.883a3.236,3.236,0,0,0-3.277-3.2.738.738,0,0,0-.613.286,2.492,2.492,0,0,1-.547.534,2.587,2.587,0,0,1-3.574-.531.742.742,0,0,0-.613-.289,3.184,3.184,0,0,0-3.216,3.2Zm1.521,0a1.716,1.716,0,0,1,1.379-1.694,4.062,4.062,0,0,0,5.408.529,4.165,4.165,0,0,0,.6-.529,1.742,1.742,0,0,1,1.408,1.695v4.078h-8.8Z",
    transform: "translate(-238.097 -353.169)",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13125",
    "data-name": "Path 13125",
    d: "M407.023,339.838a3.525,3.525,0,1,0-3.525-3.525A3.524,3.524,0,0,0,407.023,339.838Zm0-5.528a2,2,0,1,1-2,2A2,2,0,0,1,407.023,334.31Z",
    transform: "translate(-359.645 -298.281)",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13126",
    "data-name": "Path 13126",
    d: "M389.7,394.37a.738.738,0,0,0-.613.286,2.508,2.508,0,0,1-.547.534,2.556,2.556,0,0,1-3.574-.528.745.745,0,0,0-.612-.292,3.247,3.247,0,0,0-3.29,3.2v4.883a.761.761,0,0,0,.8.716h10.319a.687.687,0,0,0,.717-.716v-4.883a3.174,3.174,0,0,0-3.2-3.2Zm.31,1.5a1.711,1.711,0,0,1,1.374,1.695v4.078h-8.8v-4.078A1.749,1.749,0,0,1,384,395.875a4.078,4.078,0,0,0,6.009,0Z",
    transform: "translate(-339.651 -353.169)",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13127",
    "data-name": "Path 13127",
    d: "M51.548,25.279a4.3,4.3,0,0,0,4.291-4.3V19.563a4.29,4.29,0,0,0-8.581,0V20.98A4.3,4.3,0,0,0,51.548,25.279Zm-2.77-5.716a2.77,2.77,0,0,1,5.54,0V20.98a2.77,2.77,0,0,1-5.54,0Z",
    transform: "translate(-42.122 -15.273)",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13128",
    "data-name": "Path 13128",
    d: "M.031,123.239A2.646,2.646,0,0,0,2.719,125.9h0l.03.027a2.637,2.637,0,0,0,1.324-.36l.483,16.269a2.876,2.876,0,0,0,4.992,1.847,2.875,2.875,0,0,0,4.992-1.846l.483-16.234a2.631,2.631,0,0,0,1.317.352,2.7,2.7,0,0,0,2.7-2.715V112.394a4.417,4.417,0,0,0-3.945-4.827c-.146-.016-.292-.025-.438-.027H12.791a.766.766,0,0,0-.52.21L9.55,110.305l-2.615-2.547a.765.765,0,0,0-.53-.219H4.426A4.425,4.425,0,0,0,0,111.984c0,.136.031.274.031.41Zm11.656,19.852a1.342,1.342,0,0,1-1.337-1.356V125.743a.76.76,0,0,0-1.521,0v15.991a1.371,1.371,0,0,1-2.741.044l-.566-18.706h8.056l-.545,18.7A1.352,1.352,0,0,1,11.686,143.091ZM2.363,109.919a2.9,2.9,0,0,1,2.063-.858H6.1L9.01,111.9l.015.015.031.029.028.022.033.024.03.019.034.019.033.017a.3.3,0,0,0,.033.015l.036.014.033.011.037.011.034.008.038.007.035,0,.037,0h.072l.037,0,.035,0,.038-.006.034-.007.037-.009.033-.011.036-.013.033-.014.034-.017.033-.018.032-.02a.341.341,0,0,0,.032-.022l.03-.023.029-.025c.005,0,.011-.013.017-.018l3.032-2.849h1.563a3,3,0,0,1,2.26,1.079,2.888,2.888,0,0,1,.625,2.14c0,.025-.022.052-.022.078v10.88a1.195,1.195,0,0,1-2.39,0v-2.368l.011-.378c0-.053-.011-.1-.011-.155v-4.38a.76.76,0,0,0-1.521,0v4.891l.015.706H5.477l-.019-1.117c0-.036,0-.06,0-.095v-4.385a.76.76,0,0,0-1.521,0v7.229a1.2,1.2,0,0,1-1.206,1.192H2.719a1.131,1.131,0,0,1-.831-.322,1.11,1.11,0,0,1-.337-.816V112.357c0-.026-.014-.051-.016-.077-.01-.1-.021-.2-.021-.3A2.9,2.9,0,0,1,2.363,109.919Z",
    transform: "translate(0 -97.512)",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13129",
    "data-name": "Path 13129",
    d: "M183.938,23.323h1.2V38.855A3.048,3.048,0,0,0,188.2,41.9h9.566l-5.274,4.709A.765.765,0,0,0,193,47.941a.754.754,0,0,0,.505-.191l5.828-5.191,5.828,5.192a.761.761,0,0,0,1.074-.062.773.773,0,0,0-.062-1.084L200.895,41.9h9.566a3.015,3.015,0,0,0,3.024-3.041V23.323h1.275a.8.8,0,0,0,.789-.781v-5.22a.763.763,0,0,0-.789-.734H183.938a.736.736,0,0,0-.758.734v5.22A.775.775,0,0,0,183.938,23.323Zm28.026,15.532a1.493,1.493,0,0,1-1.5,1.521H188.2a1.525,1.525,0,0,1-1.542-1.521V23.323h25.308ZM184.7,18.109h29.327V21.8H184.7Z",
    transform: "translate(-163.272 -16.445)",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13130",
    "data-name": "Path 13130",
    d: "M240.907,121.054h14.012a.76.76,0,1,0,0-1.521H240.907a.76.76,0,1,0,0,1.521Z",
    transform: "translate(-214.047 -108.202)",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13131",
    "data-name": "Path 13131",
    d: "M240.907,149.038h18.465a.76.76,0,1,0,0-1.521H240.907a.76.76,0,1,0,0,1.521Z",
    transform: "translate(-214.047 -133.145)",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13132",
    "data-name": "Path 13132",
    d: "M240.907,176.023h18.465a.76.76,0,1,0,0-1.521H240.907a.76.76,0,1,0,0,1.521Z",
    transform: "translate(-214.047 -157.197)",
    strokeWidth: 0.4
  })))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "experience-filled",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.178,
    height: 50.4,
    viewBox: "0 0 44.178 50.4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "experience",
    transform: "translate(0.2 0.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11353",
    "data-name": "Group 11353",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13118",
    "data-name": "Path 13118",
    d: "M406.421.258l.866,2.436a.391.391,0,0,0,.2.229l2.164.975a.432.432,0,0,1,0,.763l-2.164.975a.391.391,0,0,0-.2.229L406.421,8.3a.351.351,0,0,1-.678,0l-.866-2.436a.391.391,0,0,0-.2-.229l-2.164-.975a.432.432,0,0,1,0-.763l2.164-.975a.391.391,0,0,0,.2-.229l.866-2.436A.351.351,0,0,1,406.421.258Z",
    transform: "translate(-366.106)",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 1.402,
    cy: 1.402,
    r: 1.402,
    transform: "translate(5.625 1.295)",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 0.816,
    cy: 0.816,
    r: 0.816,
    transform: "translate(0 6.699)",
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11354",
    "data-name": "Group 11354",
    transform: "translate(1.909 7.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13119",
    "data-name": "Path 13119",
    d: "M86.015,79.157h-.17V77.113a3.269,3.269,0,0,0-3.266-3.266h-.028a3.269,3.269,0,0,0-3.266,3.266v2.044H77.732V77.113a3.269,3.269,0,0,0-3.266-3.266h-.028a3.269,3.269,0,0,0-3.266,3.266v2.044H69.618v-2.03a3.28,3.28,0,1,0-6.559,0v2.03H61.5V77.113a3.269,3.269,0,0,0-3.266-3.266h-.028a3.269,3.269,0,0,0-3.266,3.266v2.044h-.219A3.327,3.327,0,0,0,51.4,82.48V87.8a3.318,3.318,0,0,0,1.243,2.589V109.42a7.223,7.223,0,0,0,7.215,7.215H80.93a7.223,7.223,0,0,0,7.215-7.215V90.346A3.317,3.317,0,0,0,89.339,87.8V82.48a3.327,3.327,0,0,0-3.323-3.323Zm-4.768-2.044a1.306,1.306,0,0,1,1.3-1.3h.028a1.306,1.306,0,0,1,1.3,1.3V82.2a1.306,1.306,0,0,1-1.3,1.3h-.028a1.306,1.306,0,0,1-1.3-1.3Zm-8.114,0a1.306,1.306,0,0,1,1.3-1.3h.028a1.306,1.306,0,0,1,1.3,1.3V82.2a1.306,1.306,0,0,1-1.3,1.3h-.028a1.306,1.306,0,0,1-1.3-1.3Zm-8.114.014a1.318,1.318,0,1,1,2.636,0v5.064a1.318,1.318,0,0,1-2.636,0Zm-8.114-.014a1.306,1.306,0,0,1,1.3-1.3h.028a1.306,1.306,0,0,1,1.3,1.3V82.2a1.306,1.306,0,0,1-1.3,1.3h-.028a1.306,1.306,0,0,1-1.3-1.3ZM53.364,82.48a1.364,1.364,0,0,1,1.362-1.362h.219V82.2a3.269,3.269,0,0,0,3.266,3.266h.028A3.269,3.269,0,0,0,61.5,82.2V81.118h1.555v1.073a3.28,3.28,0,0,0,6.559,0V81.118h1.555V82.2a3.269,3.269,0,0,0,3.266,3.266h.028A3.269,3.269,0,0,0,77.732,82.2V81.118h1.555V82.2a3.269,3.269,0,0,0,3.266,3.266h.028A3.269,3.269,0,0,0,85.845,82.2V81.118h.17a1.364,1.364,0,0,1,1.362,1.362V87.8a1.364,1.364,0,0,1-1.362,1.362H54.726A1.364,1.364,0,0,1,53.364,87.8Zm32.819,26.94a5.259,5.259,0,0,1-5.254,5.254H59.861a5.259,5.259,0,0,1-5.254-5.254v-18.3c.04,0,.079,0,.119,0H86.015q.085,0,.168,0Z",
    transform: "translate(-51.403 -73.847)",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13120",
    "data-name": "Path 13120",
    d: "M217.732,290.671h-2.558a.981.981,0,1,0,0,1.961h1.577v10.987a.981.981,0,1,0,1.961,0V291.652a.981.981,0,0,0-.981-.981Z",
    transform: "translate(-198.296 -269.497)",
    strokeWidth: 0.4
  }))))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-warning",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.56b768016271aa4232dff5a560e0e8d7.svg";
export { ForwardRef as ReactComponent };